// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fc-0";
export var headerCellHover = "_fc-1";
export var readCellContainer = "_fc-2";
export var unreadIndicator = "_fc-3";